export default "__VITE_ASSET__1de23cb5__"